import API from './index';

export const pricingAPI = {
  getAll: (type) => API.get('/pricing', { params: { type } }),
  getAdminAll: () => API.get('/pricing/all'),
  create: (pricing) => API.post('/pricing', pricing),
  update: (id, pricing) => API.put(`/pricing/${id}`, pricing),
  delete: (id) => API.delete(`/pricing/${id}`)
};